import {
  appSync,
  appLogout,
  appOpened,
  disablePopups,
  enablePopups,
  startListening,
} from '@bonanza-social/toolkit/state';
import { apiConfig } from '@bonanza-social/toolkit/api';
import { config } from '../config';

export const loadSmartico = () =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.src = 'https://d312ucx3huj7iy.cloudfront.net/s.js';

    script.onload = () => {
      if (window._smartico) {
        resolve(window._smartico);
      } else {
        reject(new Error('Smartico load error'));
      }
    };

    script.onerror = reject;

    document.body.appendChild(script);
  });

if (config) {
  startListening({
    actionCreator: appOpened,
    effect: async () => {
      await loadSmartico();

      window._smartico.init(config.labelKey, {
        brand_key: config.brandKey,
      });

      window._smartico_allow_localhost = true;

      const userId = await apiConfig.getUserId();

      if (!userId) {
        window._smartico_user_id = null;
        window._smartico_language = null;
      }
    },
  });

  startListening({
    actionCreator: appSync,
    effect: async () => {
      const userId = await apiConfig.getUserId();

      window._smartico_user_id = Number(userId);
      window._smartico_language = 'en';
    },
  });

  startListening({
    actionCreator: appLogout,
    effect: () => {
      window._smartico_user_id = null;
      window._smartico_language = null;
    },
  });

  startListening({
    actionCreator: disablePopups,
    effect: () => {
      window._smartico.suspendPopups(true);
    },
  });

  startListening({
    actionCreator: enablePopups,
    effect: () => {
      window._smartico.suspendPopups(false);
    },
  });
}
